import * as React from 'react'

import useEventIdCallback from '../../../../../../hooks/useEventIdCallback'
import RouterLink from '../../../../../common/RouterLink/RouterLink'
import type {LogView} from '../../../BuildLog.types'
import {getFullBuildLogLinkParams, LINKED_MESSAGE_TITLE} from '../../../BuildLog.utils'
import {BuildIdContext, TargetContext} from '../../../FullBuildLog/FullBuildLog.context'

type Props = {
  linkedMessageId: number
  onClick: (event: React.MouseEvent<any>, id: number) => unknown
  logView: LogView
}

function LinkedMessage({linkedMessageId, onClick, logView}: Props) {
  const buildId = React.useContext(BuildIdContext)
  const target = React.useContext(TargetContext)
  const handleClick = useEventIdCallback<React.MouseEvent, number>(onClick, linkedMessageId)

  if (buildId == null) {
    return null
  }

  return (
    <RouterLink
      params={getFullBuildLogLinkParams({
        line: linkedMessageId,
        expandState: [linkedMessageId],
        expandAll: false,
        logView,
        buildId,
        target,
      })}
      onClick={handleClick}
    >
      {LINKED_MESSAGE_TITLE}
    </RouterLink>
  )
}

export default React.memo<Props>(LinkedMessage)
